const mutations = {
  // 保存监控大屏mqtt数据
  saveMonitor_mqttMessages(state, data){
    state.monitor_mqttMessages = data;
  },

  //用户行为信息的数据
  saveUserEventLog(state,data){
    state.userEventLog=data;
  },

 //用户所有的行为信息
  saveUserAllEventLog(state,data){
    state.userAllEventLog=data;
  }

}

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations/index.js